import axios from 'axios';
import moment from "moment";
import { history } from "../utils";
const CORS = 'https://cors-anywhere.herokuapp.com/';
const BASE_API_URL = process.env.REACT_APP_API_URL_TAKE_TEST;
export const VPT_BASE_API_URL = process.env.REACT_APP_API_URL_VPT;
export const REPORT_API_URL = process.env.REACT_APP_API_REPORT_URL;
const ENVIRONEMNT_VAR = process.env.REACT_APP_ENVIRONEMNT;
console.log(ENVIRONEMNT_VAR)

var REACT_APP_API_TOKEN = getUrlParameter('token');
if (REACT_APP_API_TOKEN) {
  localStorage.setItem('token', REACT_APP_API_TOKEN);
}
const http = axios.create();

const headers = {
  // "Access-Control-Allow-Origin": "*",
  'Content-Type': 'application/json'
}




export const verifyUserEmailChange = async (token) => {
  try {
    const formData = new FormData();
    formData.append("details", token);

    const response = await axios.post(
      `${BASE_API_URL}/user/emailVerify`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const setNewAccessToken = async () =>{
//     http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('refresh_token')}`;
//     let response = await http.get(`${BASE_API_URL}/auth/refresh`);
//     if (response.data.status == 200) {
//       let token = response.data.token;
//       http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//       REACT_APP_API_TOKEN = token;
//   }
// }

export const getQuestionSolution = async (image_url) => {
  try {
    let response = await axios.get(`${image_url}`);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export function setGlobalToken(token) {
  try {
    token = token ? token : REACT_APP_API_TOKEN;
    http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    // let search = window.location.search.slice(1)
    // let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/==/g, '').replace(/=/g,
    // '":"') + '"}');
    // if (queryParams && queryParams.refresh_token) {
    //   localStorage.setItem('refresh_token', queryParams.refresh_token);
    // }
  } catch (error) {
    console.log(error);
  }
}

export const submitReport = async (data) => {
  try {
    setGlobalToken();
    let formData = new FormData();
    formData.append('category_id', data.category_id);
    formData.append('content_id', data.content_id);
    formData.append('issue', data.issue);
    formData.append('additional_comments', data.comments);
    formData.append('device', data.device);
    let response = await http.post(`${REPORT_API_URL}/user/v2/reportIssue`, formData);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.post(`${REPORT_API_URL}/user/reportIssue`, formData);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }
  } catch (error) {
    throw error
  }
}



export const getVPTTest = async id => {
  try {
    if (!id) {
      return {
        error: "No id to get test"
      };
    }
    let userToken = getUrlParameter('user');
    if (userToken) localStorage.setItem('user', userToken);
    else {
      alert('No user token passed');
      return;
    }
    http.defaults.headers.common['Authorization'] = `Bearer ${userToken}`;
    let endpoint = `${VPT_BASE_API_URL}/test/getTest?test_id=${id}`;
    let options = {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json"
      },
      method: "GET",
      mode: "cors"
    };
    return fetch(endpoint, options)
      .then(res => res.json())
      .then(json => {
        return json;
      });
  } catch (error) {

  }
}

export const getCollegeId = async () => {
  try {
    setGlobalToken();
    const response = await http.get(`${BASE_API_URL}/user/getCollegeId`);
    console.log(response);
    if(response.status === 200 && response.data?.collegeId) return response.data.collegeId;
    return false;
  } catch (error) {

  }
}

export const getTest = async (id) => {
  if (!id) {
    return {
      error: "No id to get test"
    };
  }
  setGlobalToken();
  // const college_id  = await getCollegeId();
  // if(college_id){


  const IPADDRESS = await fetch("https://api.ipify.org?format=json&callback=?").then(res => res.json()).then(data => data?.ip ? data.ip : "").catch(err => console.log(err));
  
  // new Lamda
  const apiEndPoint = `https://bgwwm5z2al.execute-api.ap-south-1.amazonaws.com/${ENVIRONEMNT_VAR}/questionnaire?test_id=${id}&device_type=1&device_details=${IPADDRESS}` ;
  // const apiEndPoint = `https://qsdsbm4079.execute-api.ap-south-1.amazonaws.com/test/questionnaire?test_id=${id}&device_type=1&device_details=${IPADDRESS}` ;
  
  // Old Lamda
  // const apiEndPoint = `https://sld1hdwfsk.execute-api.ap-south-1.amazonaws.com/test/questionnaire?test_id=${id}&device_type=1&device_details=${IPADDRESS}`
  
  // Old ec2 version
  // const apiEndPoint = `${BASE_API_URL}/questionnaire/v3/getTest?test_id=${id}&device_type=1&device_details=${IPADDRESS}`;

  // let response = await http.get(`${BASE_API_URL}/questionnaire/v${college_id === 38 ? "3" : "2"}/getTest?test_id=${id}&device_type=1&device_details=${IPADDRESS}`);
  // let response = await http.get(`${BASE_API_URL}/questionnaire/v3/getTest?test_id=${id}&device_type=1&device_details=${IPADDRESS}`);
  let response = await http.get(apiEndPoint);
  if (response.status == 200) {
    if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
      let response1 = await http.get(apiEndPoint);
      if (response1.status == 200) {
        if (response1.data.status == 200) {
          if (response1.data.date_of_expiry) {
            let date = new Date();
            let difference = moment.duration(moment(response1.data.date_of_expiry).diff(moment(date)));
            let difference2 = parseInt(difference.asSeconds());
            if (response1.data.timelimit > difference2) {
              response1.data.expiryTime = difference2;
            } else response1.data.expiryTime = response1.data.timelimit;
          }
          localStorage.setItem('subject_id', response1.data.subject_id);
          return response1.data;
        }
      }
    } else {
      if (response.data.status == 200) {
        if (response.data.date_of_expiry) {
          let date = new Date();
          let difference = moment.duration(moment(response.data.date_of_expiry).diff(moment(date)));
          let difference2 = parseInt(difference.asSeconds());
          if (response.data.timelimit > difference2) {
            response.data.expiryTime = difference2;
          } else response.data.expiryTime = response.data.timelimit;
        }
        localStorage.setItem('subject_id', response.data.subject_id);
        return response.data;
      }
      else if (response.data.status == 409) {
        return { "message": response.data.message, status: 409 }
      }
      else if (response.data.status == 204) {
        console.log(response)
        return { message: "This test is not added to you!", status: 204 }
      }
    }
  }
  // }
  // else return { message: "Student Not Found", status: 204 }
};

export const updateSeenStatus = (test_id) => {
  const formdata = new FormData();
  formdata.append("test_id",test_id);
  formdata.append("type", 1);
  formdata.append("device",1);
  http.post(`${BASE_API_URL}/questionnaire/v3/updateSeenStatus`, formdata)
  .then((res)=> {
      console.log(res);
  });
}

// ---------------------- SUBMIT MCQ TEST -------------------------

// Testing QUestions Submission API 
export const submitMCQQuestion = async (payload) =>{

  const {questionData,tid} = payload;

      const fetchData = async () =>{

          //If not payload is provided
          if (!payload) {
              return {
                error: "No body to submit"
              };
          }
          console.log('submitting question api');
          
          // const questionVisitDuration = moment().diff(questionData.started_time, "seconds");
          // console.log(questionVisitDuration);
      
          const question = {
            ...questionData,
          };

          // console.log(`Before adding keys in submitQuestion`);
          // console.log(JSON.stringify(question));
      
          if(!question.action_type) question.action_type = 1;
          if (!question.question_option_id) question.question_option_id = null;
          question.total_timetaken = question.timetaken[2];
          // console.log(JSON.stringify(question));
      
      
          const form_data = {
            questionnaire_id : parseInt(tid),
            // question_answers : JSON.stringify([question]),
            question_answers : [question],
            subject_id : parseInt(localStorage.getItem('subject_id')),
            total_timetaken : question.timetaken[2],
          }

          setGlobalToken();

          const controller = new AbortController();

          const timeout = setTimeout(() => {
            controller.abort();
            // Timeout Logic
          }, 45000);

          const apiEndPoint = `https://kaecu866ya.execute-api.ap-south-1.amazonaws.com/${ENVIRONEMNT_VAR}/mcqQuesSubmissions` ;

          let response = await http
            .post(apiEndPoint, form_data, {
              headers: { "Content-Type": "application/json" },
              signal: controller.signal,
            })
            .then((res) => res);

          clearTimeout(timeout);
      
          // setGlobalToken();
          // const response = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqQuestionSubmission`, form_data).then(res => res);
      
      
          if (response.status === 200) {
            if (response.data.status === 500 ||response.data.status === 502 || response.data.status === 503) {
              const controller1 = new AbortController();

              const timeout1 = setTimeout(() => {
                controller1.abort();
                // Timeout Logic
              }, 45000);

              const response1 = await http
                .post(apiEndPoint, form_data, {
                  headers: { "Content-Type": "application/json" },
                  signal: controller1.signal,
                })
                .then((res) => res);

                clearTimeout(timeout1);

              return response1
            } 
            else if (response.data.status === 409) {
              console.log(response);
              return history.push(`/completed`);
            }
          }
          return response;
      };      


      try {
          const data = await fetchData();
          // console.log(data);
          // dispatch(resetQuestionTime()) 
          return data

      } catch (error) {
      //  alert(error?.message);
       console.log(error)  
       return new Error(error);
      }
}


// API to submit the MCQ Test
export const submitMCQTest = async (body,type) => {
  if (!body) {
    return {
      error: "No question to submit"
    };
  }
  try {
    console.log('submitting mcq test');

    const {questionData,tid} = body;

    const question = {
      ...questionData,
    }
    console.log(`Before adding keys in submitMCQTest`);
    console.log(JSON.stringify(question));

    if(!question.action_type) question.action_type = 1;
    if (!question.question_option_id) question.question_option_id = null;
    question.total_timetaken = question.timetaken[2];
    console.log(JSON.stringify(question));

    // const form_data = new FormData();
    // form_data.append("questionnaire_id", tid);
    // form_data.append("question_answers", JSON.stringify([question]));
    // form_data.append("subject_id", localStorage.getItem('subject_id'));
    // form_data.append('test_submission_type', type);


    const form_data = {
      questionnaire_id : parseInt(tid),
      question_answers : [question],
      subject_id : parseInt(localStorage.getItem('subject_id')),
      test_submission_type : parseInt(type),
    }
    setGlobalToken();
    
    const controller = new AbortController();

    const timeout = setTimeout(() => {
      controller.abort();
      // Timeout Logic
    }, 45000);

    const apiEndPoint = `https://q6wjgn02f4.execute-api.ap-south-1.amazonaws.com/${ENVIRONEMNT_VAR}/testsubmission` ;
    let response = await http.post(apiEndPoint, form_data, {
      headers: { "Content-Type": "application/json" },
      signal: controller.signal,
    });

    clearTimeout(timeout);


    if (response.status == 200) {
      // Hitting the API second time if it it is a 500,502 or 503 errors.
      if (response.data.status == 500 ||response.data.status == 502 || response.data.status == 503) {
        
        const controller1 = new AbortController();

        const timeout1 = setTimeout(() => {
          controller1.abort();
          // Timeout Logic
        }, 45000);
        
        let response1 = await http.post(apiEndPoint, form_data, {
          headers: { "Content-Type": "application/json" },
          signal: controller1.signal,
        });
        clearTimeout(timeout1);
        console.log(response1);

        

        if (response1.status === 200 && response1.data.status === 200) {
          return true;
        }

        // Hitting the API third time if it it is a 500,502 or 503 errors.
        else if (response1.data.status == 500 ||response1.data.status == 502 || response1.data.status == 503) {
          
          const controller2 = new AbortController();

          const timeout2 = setTimeout(() => {
            controller2.abort();
            // Timeout Logic
          }, 45000);
          
          let response2 = await http.post(apiEndPoint, form_data, {
            headers: { "Content-Type": "application/json" },
            signal: controller2.signal,
          });
          clearTimeout(timeout2);

          console.log(response2);

          if (response2.status === 200 && response2.data.status === 200) {
            return true;
          }
        }
        else if (response1.status !== 200) {
          return false;
        }
      } 
      else if (response.data.status == 200) {
        return true;
      }
      console.log(response);
    }
    else return false;


    // http
    //   .post(
    //     `https://mk2dp5bcoi.execute-api.ap-south-1.amazonaws.com/test/testsubmission`,
    //     form_data,
    //     { headers: { "Content-Type": "application/json" } }
    //   )
    //   .then((response) => {
    //     if (response.status == 200) {
    //       console.log(response);
    //       if (response.data.status == 200) {
    //         return true;
    //     }
    //     else return false;
    //   }
    //   });

  } catch (error) {
    console.log(error)
  }
};



// Old version of the code
// ----------------------------------------------------------------------------------------------------------------------------
// export const submitQuestion = async (body) => {
//   if (!body) {
//     return {
//       error: "No body to submit"
//     };
//   }
//   try {

//     console.log('submitting question');

//     const {questionData,tid} = body;

//     const question = {
//       ...questionData,
//     }
//     console.log(`Before adding keys in submitQuestion`);
//     console.log(JSON.stringify(question));

//     question.device = 1;
//     if(!question.action_type) question.action_type = 1;
//     if (!question.question_option_id) question.question_option_id = null;
//     question.total_timetaken = question.timetaken[2];
//     console.log(JSON.stringify(question));

//     // const form_data = new FormData();
//     // form_data.append("questionnaire_id", tid);
//     // form_data.append("question_answers", JSON.stringify([question]));
//     // form_data.append("subject_id", localStorage.getItem('subject_id'));
//     // form_data.append('total_timetaken', question.timetaken);


//     const form_data = {
//       questionnaire_id : parseInt(tid),
//       // question_answers : JSON.stringify([question]),
//       question_answers : [question],
//       subject_id : parseInt(localStorage.getItem('subject_id')),
//       total_timetaken : question.timetaken[2],
//     }




//     setGlobalToken();
//     let response = await http.post(
//       `https://5x9619yt5a.execute-api.ap-south-1.amazonaws.com/test/questionsubmission`,
//       form_data,
//       { headers: { "Content-Type": "application/json" } }
//     ).then(res => res);

//     // setGlobalToken();
//     // const response = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqQuestionSubmission`, form_data).then(res => res);


//     if (response.status === 200) {
//       // if (response.data.status === 500 && response.data.message === 'Invalid token. Please log in again.') {
//       if (response.data.status == 500 ||response.data.status == 502 || response.data.status == 503) {
//         const response1 = await http.post(`https://5x9619yt5a.execute-api.ap-south-1.amazonaws.com/test/questionsubmission`, form_data).then(res => res);
        
//         if(response1.data.message === "This test is already submitted!") return false;
//         // if (response1.data.status === 200 && response1.data.message !== "This test is already submitted!") return true;
//         else return true;
//       } else {
//         if(response.data.message === "This test is already submitted!") return false;
//         // if (response.data.status === 200 && response.data.message !== "This test is already submitted!") return true;
//         else return true;
//       }
//     }
//     else return true;
//   } catch (error) {
//     console.log(error)
//   }
// };
// ----------------------------------------------------------------------------------------------------------------------------
//Question Submission
// export const submitQuestion = async (body,tid) => {
//   if (!body) {
//     return {
//       error: "No body to submit"
//     };
//   }
//   try {
//     const question = {
//       ...body,
//       timetaken: JSON.stringify(body.timetaken)
//     }
//     // question.timetaken = [1];
//     if(typeof (question.timetaken) === "string") question.timetaken = JSON.parse(question.timetaken);
//     question.timetaken = question.timetaken.map(time => {
//       if(typeof (time) !== "object") return ["","",time];
//       return [...time];
//     })
//     const new_timetaken = question.timetaken.filter(time => time.length === 3);
//     const timetaken = new_timetaken.map(time => time[2]).reduce((a,b) => a+b);
//     if(!question.action_type) question.action_type = 1;
//     // const timetaken = body.timetaken.map(time => time[2]).reduce((a,b) => a+b);
//     if (typeof (question.timetaken) !== "string") question.timetaken = JSON.stringify([...new_timetaken]);
//     if (!question.question_option_id) question.question_option_id = null;
//     question.total_timetaken = timetaken;
//     question.device = 1;
//     console.log(JSON.stringify(question));

//     const form_data = new FormData();
//     form_data.append("questionnaire_id", tid);
//     form_data.append("question_answers", JSON.stringify([question]));
//     form_data.append("subject_id", localStorage.getItem('subject_id'));
//     form_data.append('total_timetaken', timetaken);
    
//     setGlobalToken();
//     const response = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqQuestionSubmission`, form_data).then(res => res);
//     if (response.status === 200) {
//       if (response.data.status === 500 && response.data.message === 'Invalid token. Please log in again.') {
//         const response1 = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqQuestionSubmission`, form_data).then(res => res);
//         if(response1.data.message === "This test is already submitted!") return false;
//         // if (response1.data.status === 200 && response1.data.message !== "This test is already submitted!") return true;
//         else return true;
//       } else {
//         if(response.data.message === "This test is already submitted!") return false;
//         // if (response.data.status === 200 && response.data.message !== "This test is already submitted!") return true;
//         else return true;
//       }
//     }
//     else return true;
//   } catch (error) {
//     console.log(error)
//   }
// };

// MCQ Submission
// export const submitMCQTest = async (body,type) => {
//   if (!body) {
//     return {
//       error: "No body to submit"
//     };
//   }
//   try {
//     console.log('submitting mcq test');
//     let answers = body.question_answers.map((question) => {
//       let question1 = { 
//         ...question,
//         timetaken: typeof(question.timetaken) !== "string" ? JSON.parse(JSON.stringify(question.timetaken)) : JSON.parse(question.timetaken)
//       }
//       // question1.timetaken = [1];
//       question1.timetaken = question1.timetaken.map(time => {
//         if(typeof (time) !== "object") return ["","",time];
//         return [...time];
//       });
//       delete question1['isBookMarked'];
//       if (!question1.question_option_id) question1.question_option_id = null;
//       const timetaken = question1.timetaken.filter(time => time.length === 3).map(time => time[2]);
//       question1.total_timetaken = timetaken.length > 0 ? timetaken.reduce((a,b) => a+b) : 0;
//       if(typeof (question1.timetaken) !== "string") question1['timetaken'] = JSON.stringify([...question1.timetaken]);
//       return question1;
//     })
//     body['subject_id'] = localStorage.getItem('subject_id')
//     const form_data = new FormData();
//     for (let key in body) {
//       if (key == 'question_answers') {
//         form_data.append(key, JSON.stringify(answers));
//       } else if (key == 'questionnaire_id' || key == 'subject_id') {
//         form_data.append(key, body[key]);
//       }
//     }
//     form_data.append("test_submission_type",type);
//     setGlobalToken();
//     let response = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqTestSubmission`, form_data);
//     if (response.status == 200) {
//       if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
//         let response1 = await http.post(`${BASE_API_URL}/questionnaire/v2/mcqTestSubmission`, form_data);
//         if (response1.status === 200 && response1.data.status === 200) {
//           return true;
//         }
//       } else {
//         if (response.data.status == 200) {
//           return true;
//         }
//       }
//       console.log(response);
//     }
//     else return false;
//   } catch (error) {
//     console.log(error)
//   }
// };

export const submitTest = async body => {
  if (!body) {
    return {
      error: "No body to submit"
    };
  }
  try {
    console.log('submitting test')
    // delete body['modalOpen'];
    // delete body['visitedTimeStamp'];
    // delete body['questionVisitDuration'];
    // body.question_answers.forEach(question => {
    //   delete question['isBookMarked'];
    //   question.timetaken = JSON.stringify(question.timetaken);
    //   if (!question.question_option_id) {
    //     question.question_option_id = 'null';
    //   }
    // });
    let answers = body.question_answers.map((question) => {
      let question1 = { ...question }
      delete question1['isBookMarked'];
      question1['timetaken'] = JSON.stringify([...question1.timetaken])
      if (!question1.question_option_id) {
        question1.question_option_id = 'null';
      }
      return question1
    })
    body['subject_id'] = localStorage.getItem('subject_id')
    var form_data = new FormData();
    for (var key in body) {
      if (key == 'question_answers') {
        form_data.append(key, JSON.stringify(answers));
      } else if (key == 'questionnaire_id' || key == 'subject_id') {
        form_data.append(key, body[key]);
      }
    }
    setGlobalToken();
    let response = await http.post(`${BASE_API_URL}/questionnaire/v2/submitQuestionnaires`, form_data);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.post(`${BASE_API_URL}/questionnaire/submitQuestionnaires`, form_data);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return true;
          }
        }
      } else {
        if (response.data.status == 200) {
          return true;
        }
      }
      console.log(response);
    }
  } catch (error) {
    console.log(error)
  }
};

// GET RESULTS
export const getResults = async id => {
  if (!id) {
    return {
      error: "No id to get test results"
    };
  }
  setGlobalToken();
  let response = await http.get(`${BASE_API_URL}/questionnaire/v2/testSubmittedAnswers?test_id=${id}`);
  if (response.status == 200) {
    if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
      let response1 = await http.get(`${BASE_API_URL}/questionnaire/testSubmittedAnswers?test_id=${id}`);
      if (response1.status == 200) {
        if (response1.data.status == 200) {
          return response1.data;
        }
      }
    } else {
      if (response.data.status == 200) {
        return response.data;
      }
    }
    console.log(response);
  }
};

// GET RESULTS
export const getBookmarkedQuestions = async subjectId => {
  if (!subjectId) {
    return {
      error: "No id to get test results"
    };
  }

  setGlobalToken()
  let response = await http.get(`${BASE_API_URL}/v2/getBookmarkedQuestions?subject_id=${subjectId}`);
  if (response.status == 200) {
    if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
      let response1 = await http.get(`${BASE_API_URL}/getBookmarkedQuestions?subject_id=${subjectId}`);
      if (response1.status == 200) {
        if (response1.data.status == 200) {
          return response1.data;
        }
      }
    } else {
      if (response.data.status == 200) {
        return response.data;
      }
    }
    console.log(response);
  }
};


export const getTestSummary = async (testId) => {
  try {
    setGlobalToken()
    let response = await http(BASE_API_URL + '/questionnaire/v2/questionnaireSummaryDetails?questionnaire_id=' + testId);
    console.log(response)
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        console.log('inside refresh token')
        let response1 = await http.get(`${BASE_API_URL}/questionnaire/questionnaireSummaryDetails?questionnaire_id=${testId}`);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

// GET PRACTICE TEST
export const getPracticeTest = async params => {
  if (!params) {
    return {
      error: "No params to get test results"
    };
  }
  let suburl = '';
  let search = window.location.search.slice(1);
  let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/==/g, '').replace(/=/g,
    '":"') + '"}');
  if (queryParams && queryParams.practiceType == 'topic_practice_test') {
    suburl = 'getTopicPracticeTest';
    localStorage.setItem('practice_type', queryParams.practiceType);
  } else if (queryParams && queryParams.practiceType == 'unit_practice_test') {
    suburl = 'getUnitPracticeTest';
    localStorage.setItem('practice_type', queryParams.practiceType);
  } else if (queryParams && queryParams.practiceType == 'learning_practice_test') {
    suburl = 'getLearningPracticeTest';
    localStorage.setItem('practice_type', queryParams.practiceType);
  } else if (queryParams && queryParams.practiceType == 'end_exam_practice_test') {
    suburl = 'getLearningPracticeTest';
    localStorage.setItem('practice_type', queryParams.practiceType);
  } else if (queryParams && queryParams.code) {
    suburl = 'getTopicPracticeTest';
    localStorage.setItem('practice_type', 'topic_practice_test');
  } else if (queryParams && queryParams.practice_id) {
    suburl = 'getLearningPracticeTest';
    localStorage.setItem('practice_type', 'learning_practice_test');
  } else {
    suburl = 'getUnitPracticeTest';
    localStorage.setItem('practice_type', 'unit_practice_test');
  }

  if (queryParams && queryParams.practice_id) {
    suburl = 'getLearningPracticeTest'
  }

  console.log(queryParams.subject_id)
  if (queryParams.subject_id == 136) {
    return { "subject_id": 136 }
  }

  setGlobalToken()
  let response = await http.get(`${BASE_API_URL}/units/v2/${suburl}${params}`);
  if (response.status == 200) {
    if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
      let response1 = await http.get(`${BASE_API_URL}/units/${suburl}${params}`);
      if (response1.status == 200) {
        if (response1.data.status == 200) {
          return response1.data;
        }
      }
    } else {
      if (response.data.status == 200) {
        return response.data;
      }
    }
    console.log(response);
  }
};
//add bookmark for a question
export const addQuestionBookmark = async (qid) => {
  try {
    if (!qid) {
      return {
        error: "No question id to add bookmark"
      };
    }
    let formdata = new FormData()
    formdata.append('id', qid)
    formdata.append('type', 'question')
    setGlobalToken()
    let response = await http.post(`${BASE_API_URL}/v2/addBookmark`, formdata);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.post(`${BASE_API_URL}/addBookmark`, formdata);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }

  } catch (error) {
    console.log(error);
  }
}
//delete bookmark for a question
export const deleteQuestionBookmark = async (qid) => {
  try {
    if (!qid) {
      return {
        error: "No question id to delete bookmark"
      };
    }
    let formdata = new FormData()
    formdata.append('id', qid)
    formdata.append('type', 'question')
    setGlobalToken()
    let response = await http.post(`${BASE_API_URL}/v2/deleteBookmark`, formdata);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.post(`${BASE_API_URL}/deleteBookmark`, formdata);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}


// GET PRACTICE TEST
export const submitPracticeTest = async body => {
  if (!body) {
    return {
      error: "No body to get test results"
    };
  }
  localStorage.setItem('body', body);
  console.log(body);
  delete body['modalOpen'];
  delete body['visitedTimeStamp'];
  delete body['questionVisitDuration'];
  body.answers.forEach(question => {
    delete question['isBookMarked'];
    question.timetaken = JSON.stringify(question.timetaken);
    if (!question.question_option_id) {
      question.question_option_id = 'null';
    }
  });
  var form_data = new FormData();
  for (var key in body) {
    if (key == 'answers') {
      form_data.append(key, JSON.stringify(body[key]));
    } else {
      form_data.append(key, body[key]);
    }
  }
  setGlobalToken();
  let response = await http.post(`${BASE_API_URL}/units/v2/submitUnitPracticeTest`, form_data);
  if (response.status == 200) {
    if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
      let response1 = await http.post(`${BASE_API_URL}/units/submitUnitPracticeTest`, form_data);
      if (response1.status == 200) {
        if (response1.data.status == 200) {
          localStorage.setItem('practiceTestResponse', JSON.stringify(response1.data));
          return response1.data;
        }
      }
    } else {
      if (response.data.status == 200) {
        localStorage.setItem('practiceTestResponse', JSON.stringify(response.data));
        return response.data;
      }
    }
    console.log(response);
  }

};

//get practice test results overview 
export const getPracticeTestOverview = async (tid) => {
  try {
    if (!tid) {
      return {
        error: "No test id to get pratice test overview"
      };
    }
    setGlobalToken();
    let response = await http.get(`${BASE_API_URL}/v2/practiceSummaryDetails?practice_id=${tid}`);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.get(`${BASE_API_URL}/practiceSummaryDetails?practice_id=${tid}`);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }

  } catch (error) {
    console.log(error);
  }
}

// to update learning path once practice test is submitted
export const updateLearningPath = async (practice_id, subject_id) => {
  try {
    if (!practice_id) {
      return {
        error: "No practice id to update learning path"
      };
    }
    if (!subject_id) {
      return {
        error: "No subject id to update learning path"
      };
    }
    setGlobalToken()
    let response = await http.get(`${BASE_API_URL}/v2/updateLearningPath?practice_id=${practice_id}&subject_id=${subject_id}`);
    console.log(response)
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.get(`${BASE_API_URL}/updateLearningPath?practice_id=${practice_id}&subject_id=${subject_id}`);
        console.log(response1)
        if (response1.status == 200) {
          return response1.data;
        }
      } else {
        return response.data;
      }
      console.log(response);
    }

  } catch (error) {
    console.log(error);
  }
}
// to update learning path once practice test is submitted
export const updateEndExamLearningPath = async (practice_id) => {
  try {
    if (!practice_id) {
      return {
        error: "No practice id to update learning path"
      };
    }
    setGlobalToken()
    let formdata = new FormData;
    formdata.append('practice_id', practice_id);
    let response = await http.post(`${BASE_API_URL}/v2/updateEndExamLearningPath`, formdata);
    console.log(response)
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.post(`${BASE_API_URL}/updateEndExamLearningPath`, formdata);
        console.log(response1)
        if (response1.status == 200) {
          return response1.data;
        }
      } else {
        return response.data;
      }
      console.log(response);
    }

  } catch (error) {
    console.log(error);
  }
}

//get practice test results 
export const getPracticeTestResults = async (tid) => {
  try {
    if (!tid) {
      return {
        error: "No test id to get pratice test results"
      };
    }
    setGlobalToken();
    let response = await http.get(`${BASE_API_URL}/v2/practiceSubmittedAnswers?practice_id=${tid}`);
    if (response.status == 200) {
      if (response.data.status == 500 && response.data.message == 'Invalid token. Please log in again.') {
        let response1 = await http.get(`${BASE_API_URL}/practiceSubmittedAnswers?practice_id=${tid}`);
        if (response1.status == 200) {
          if (response1.data.status == 200) {
            return response1.data;
          }
        }
      } else {
        if (response.data.status == 200) {
          return response.data;
        }
      }
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}

export function getUrlParameter(name) {
  try {
    if (name === 'token') {
      const searchParams = new URLSearchParams(window.location.search);
      const queryParams = {};
      searchParams.forEach((value,key) => queryParams[key] = value);
      // let search = window.location.search.slice(1);
      // let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,
      //           '":"') + '"}');
      let token;
      if (Object.keys(queryParams).length > 0) {
        localStorage.setItem('token', queryParams.token);
        localStorage.setItem('device', queryParams.device);
        token=queryParams.token;
      }
      else
        token = localStorage.getItem(name);
      return token;
    } else {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(window.location.search);
      let param = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      if (param)
        localStorage.setItem(name, param);
      if (!param)
        param = localStorage.getItem(name);
      return param;
    }
    
  } catch (error) {
    console.log(error);
  }
};


export const submitVptTest = async (body) => {
  try {
    console.log(body);
    let formData = new FormData();
    formData.append('test_id', body.questionnaire_id);

    body.question_answers.forEach(question => {
      delete question['isBookMarked'];
      if (!question.question_option_id) {
        question.question_option_id = 'null';
      }
    });
    formData.append('question_answers', JSON.stringify(body.question_answers));
    let response = await http.post(`${VPT_BASE_API_URL}/submissions`, formData);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    // return error(error);
  }
}

export const getLiveTest = async (tid) => {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${REACT_APP_API_TOKEN}`,
        "Content-Type": "application/json"
      },
      method: "GET",
      mode: "cors"
    };
    let rawResponse = await fetch(BASE_API_URL + '/questionnaire/getLiveTest?test_id=' + tid, options);
    let response = await rawResponse.json();
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const VerifyLiveTestCode = async (tid, code) => {
  try {
    setGlobalToken();
    console.log(tid, code)
    var formdata = new FormData();
    formdata.append("test_id", tid);
    formdata.append("code", code);
    let response = await http.post(BASE_API_URL + '/questionnaire/validateLiveTestCode', formdata);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getLiveQuestion = async (tid) => {
  try {
    setGlobalToken();
    console.log(tid)

    let response = await http.get(BASE_API_URL + `/questionnaire/getLiveQuestion?test_id=${tid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getLiveTestEndTime = async (tid) => {
  try {
    setGlobalToken();
    console.log(tid)

    let response = await http.get(BASE_API_URL + `/questionnaire/getTestEndTime?test_id=${tid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const submitLiveQuestion = async (tid, question_id, answer) => {
  try {
    setGlobalToken();
    console.log(tid, answer)
    var formdata = new FormData();
    formdata.append("test_id", tid);
    formdata.append("question_id", question_id);
    console.log(answer)
    formdata.append("answer", JSON.stringify(answer));
    let response = await http.post(BASE_API_URL + `/questionnaire/submitLiveQuestion`, formdata);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getLiveTestSummaryDetails = async (tid) => {
  try {
    setGlobalToken();
    console.log(tid)

    let response = await http.get(BASE_API_URL + `/questionnaire/getQuestionnaireLiveSummaryDetails?test_id=${tid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getLiveTestSubmittedAnswers = async (tid) => {
  try {
    setGlobalToken();
    console.log(tid)

    let response = await http.get(BASE_API_URL + `/questionnaire/getLiveTestSubmittedAnswers?test_id=${tid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const postSphereEngineSubmission = async (submission_id) => {
  try {
    setGlobalToken();
    console.log(submission_id);

    let formdata = new FormData();
    formdata.append('submission_id', submission_id)

    let response = await http.post(`${BASE_API_URL}/sphereEngine/submission`, formdata);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}


function getToken() {
  if (window.location.search) {
    let search = window.location.search.slice(1);
    let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,
      '":"') + '"}');
    if (queryParams.token) {
      localStorage.setItem('token', queryParams.token);
      return queryParams.token;
    }
    else {
      let token = localStorage.getItem('token');
      if (token) return token;
      return process.env.REACT_APP_API_TOKEN;
    }
  } else {
    let token = localStorage.getItem('token');
    if (token) return token;
    return process.env.REACT_APP_API_TOKEN;
  }
}


